export enum Packages {
  ROLE_RENT = 'Rent',
  ROLE_AUCTION = 'Aukcje i przetargi',
  ROLE_ADVERTISEMENT = 'Ogłoszenia',
  ROLE_BAILIFFNOTICE = 'Obwieszczenia komornicze',
  ROLE_COOPERATIVE = 'Spółdzielnie',
  ROLE_ANALYSIS = 'Analizy',
  ROLE_ADMIN = 'Administrator'
}
